import { render } from "./empty-submitted-message.vue?vue&type=template&id=7403f9c8&ts=true"
import script from "./empty-submitted-message.ts?vue&type=script&lang=ts&external"
export * from "./empty-submitted-message.ts?vue&type=script&lang=ts&external"

import "./empty-submitted-message.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__